import { render, staticRenderFns } from "./IcoClassContent.vue?vue&type=template&id=09df83d9"
import script from "./IcoClassContent.vue?vue&type=script&lang=js"
export * from "./IcoClassContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports